export default "__VITE_ASSET__COYsNvXs__"